import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = {
  key: 1,
  class: "m-0"
}
const _hoisted_7 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, null, -1 /* HOISTED */)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}
const _hoisted_19 = { class: "dropdown position-static" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-boundary": "viewport"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.storeEnabled)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { path: `/patient/${_ctx.patient.id}/caregivers/add` },
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cta.add_caregiver')) + " ", 1 /* TEXT */),
                  _hoisted_4
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.caregivers === undefined)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : _createCommentVNode("v-if", true),
        (_ctx.caregivers.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('feature.$caregivers.no_caregivers')), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createCommentVNode(" <th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0\">\n                ID\n              </th> "),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('form.first_name.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('form.last_name.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                    _hoisted_13
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createCommentVNode(" CENTER ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caregivers, (caregiver) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'caregiver_' + caregiver.id
                    }, [
                      _createCommentVNode(" <td class=\"shadow-none lh-1 fw-medium text-primary\" @click=\"show(caregiver)\">\n                {{ caregiver.id }}\n              </td> "),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        onClick: ($event: any) => (_ctx.show(caregiver))
                      }, _toDisplayString(caregiver.firstname), 9 /* TEXT, PROPS */, _hoisted_14),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis pe-0",
                        onClick: ($event: any) => (_ctx.show(caregiver))
                      }, _toDisplayString(caregiver.lastname), 9 /* TEXT, PROPS */, _hoisted_15),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(caregiver))
                      }, _toDisplayString(caregiver.email), 9 /* TEXT, PROPS */, _hoisted_16),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(caregiver))
                      }, _toDisplayString(caregiver.phone_number), 9 /* TEXT, PROPS */, _hoisted_17),
                      (_ctx.destroyEnabled)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("ul", _hoisted_21, [
                                _createCommentVNode(" <li>\n                      <router-link :to=\"{ path: `/center/${caregiver.id}` }\"\n                        class=\"dropdown-item d-flex align-items-center\">\n                        <i class=\"ph ph-eye lh-1 me-8 position-relative top-1\"></i>\n                        {{ $t('cta.view') }}\n                      </router-link>\n                    </li> "),
                                _createCommentVNode(" <li>\n                      <router-link :to=\"{ path: `/patient/${patient.id}/caregivers/${caregiver.id}/edit` }\"\n                        class=\"dropdown-item d-flex align-items-center\">\n                        <i class=\"ph-duotone ph-pencil lh-1 me-8 position-relative top-1\"></i>\n                        {{ $t('cta.edit') }}\n                      </router-link>\n                    </li> "),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item d-flex align-items-center",
                                    onClick: ($event: any) => (_ctx.confirmDeleteCaregiver(caregiver))
                                  }, [
                                    _hoisted_23,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_22)
                                ]),
                                _createCommentVNode(" <li>\n                      <button class=\"dropdown-item d-flex align-items-center\"\n                        v-on:click=\"(e) => recoveryPassword(user, e)\">\n                        <span v-if=\"recovery_loading\" class=\"spinner-border spinner-border-xs border-1 me-8\"\n                          role=\"status\" aria-hidden=\"true\"></span>\n                        <i v-else class=\"ph ph-arrow-clockwise lh-1 me-8 position-relative top-1\"></i>\n                        {{ $t('cta.recovery_password') }}\n                      </button>\n                    </li> ")
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])),
        _createCommentVNode(" PAGINATION "),
        _createCommentVNode(" <TablePagination :count=\"centers?.length ?? 0\" :page=\"currentPage\" :total=\"total\" :pages=\"lastPage\"\n        @change=\"setPage($event)\" /> ")
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteCaregiver())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}